import Field from '../Field';

class File extends Field {
  sanitize(force = false) {
    super.sanitize(force);

    // No sanitizing at this time
    // this.value.forEach((val, index) => {
    // });

    return this;
  }

  validate() {
    super.validate();

    this.value.forEach((val, index) => {
      if (!this.needsValidation(index)) {
        return;
      }

      if (typeof val !== 'object') {
        this.invalidate('Invalid file object.', index);
      }
    });

    return this.isValid();
  }
}

export default File;
